import { QRCodeSVG } from 'qrcode.react';
import React, { useState } from 'react';
import Barcode from 'react-barcode';
import { useTranslation } from "react-i18next";
import assetdetails from "../../images/assetdetails.png"
import { Switch } from '@mui/material';

const ViewVerifiedAsset = () => {
  const [activeTab, setActiveTab] = useState('general');
  const { t, i18n } = useTranslation();
  
  const apiOperations = [
    {
      name: "Search GPC for Classification",
      description: "GS1 Registry Platform API-v3 is a RESTful API which is used to interact with the GS1 Registry Platform.",
      type: "REST"
    },
    {
      name: "Get GTIN Product Details",
      description: "GS1 Registry Platform API-v3 is a RESTful API which is used to interact with the GS1 Registry Platform.",
      type: "REST"
    },
    {
      name: "Search Licenses",
      description: "GS1 Registry Platform API-v3 is a RESTful API which is used to interact with the GS1 Registry Platform.",
      type: "REST"
    },
    {
      name: "Get Digital Links",
      description: "GS1 Registry Platform API-v3 is a RESTful API which is used to interact with the GS1 Registry Platform.",
      type: "REST"
    }
  ]

  const [groupByTag, setGroupByTag] = useState(false)
  const [searchTerm, setSearchTerm] = useState('')

  const filteredOperations = apiOperations.filter(op => 
    op.name.toLowerCase().includes(searchTerm.toLowerCase()) ||
    op.description.toLowerCase().includes(searchTerm.toLowerCase())
  )

  return (
    <div className={`p-0 h-full ${i18n.language === 'ar' ? 'sm:mr-72' : 'sm:ml-72'}`}>
      <div className="bg-[#e9f2ee] p-4 md:p-6 rounded-lg shadow-lg mx-auto">
        <h1 className="text-xl md:text-2xl font-bold mb-4 text-blue-900">Asset Details</h1>

        {/* Tabs List */}
        <div className="grid w-full grid-cols-2 md:grid-cols-5 gap-1 p-1 rounded-lg">
          {['general', 'maintenance', 'financial', 'history', 'api'].map((tab) => (
            <button
              key={tab}
              className={`${
                activeTab === tab ? 'bg-secondary text-white hover:bg-[#95DCEA]' : 'bg-white text-blue-900 hover:bg-[#95DCEA]'
              } rounded py-2 text-xs md:text-sm font-semibold`}
              onClick={() => setActiveTab(tab)}
            >
              {tab === 'general' && 'General Information'}
              {tab === 'maintenance' && 'Maintenance Information'}
              {tab === 'financial' && 'Financial Data'}
              {tab === 'history' && 'Asset History Log'}
              {tab === 'api' && 'API Information'}
            </button>
          ))}
        </div>

        {/* Tabs Content */}
        <div className="bg-white p-4 md:p-6 rounded-sm shadow-lg mt-4">
          {activeTab === 'general' && (
            <div>
              <h2 className="text-lg font-semibold mb-2 text-blue-900">General Information</h2>
              <div className="grid grid-cols-1 md:grid-cols-4 gap-2"> {/* Reduced gap and changed grid layout */}
                {/* Left Section with Image, Barcode, and QR Code */}
                <div className="flex flex-col items-center md:col-span-1">
                  <img src={assetdetails} alt="Printer" className="mb-4" /> {/* Reduced image size */}
                  <div className='flex justify-between items-center w-full'>
                    <Barcode value='123456789012' fontSize='15px' height={50} width={1} />
                    <QRCodeSVG value='123456789012' width={60} height={60} /> {/* Adjusted barcode and QR sizes */}
                  </div>
                </div>

                {/* Asset Details Input Section */}
                <div className="md:col-span-3 grid grid-cols-1 sm:grid-cols-3 gap-3"> {/* Adjusted column span */}
                  <div className="flex flex-col">
                    <label htmlFor="assetId" className="text-sm font-medium text-gray-700">Asset ID / Tag Number</label>
                    <input id="assetId" defaultValue="020002000041" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
                  </div>

                  <div className="flex flex-col">
                    <label htmlFor="assetName" className="text-sm font-medium text-gray-700">Asset Name / Description</label>
                    <input id="assetName" defaultValue="PRINTER HP-HP205" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
                  </div>

                  <div className="flex flex-col">
                    <label htmlFor="assetCategory" className="text-sm font-medium text-gray-700">Asset Category</label>
                    <input id="assetCategory" defaultValue="Tools and Equipments" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
                  </div>

                  <div className="flex flex-col">
                    <label htmlFor="serialNumber" className="text-sm font-medium text-gray-700">Serial Number</label>
                    <input id="serialNumber" defaultValue="XYZ102002000041" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
                  </div>

                  <div className="flex flex-col">
                    <label htmlFor="minorCategory" className="text-sm font-medium text-gray-700">Minor Category</label>
                    <input id="minorCategory" defaultValue="PRINTER" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
                  </div>

                  <div className="flex flex-col">
                    <label htmlFor="manufacturer" className="text-sm font-medium text-gray-700">Manufacturer</label>
                    <input id="manufacturer" defaultValue="HP Company" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
                  </div>

                  <div className="flex flex-col">
                    <label htmlFor="brand" className="text-sm font-medium text-gray-700">Brand</label>
                    <input id="brand" defaultValue="HP" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
                  </div>

                  <div className="flex flex-col">
                    <label htmlFor="model" className="text-sm font-medium text-gray-700">Model</label>
                    <input id="model" defaultValue="HP-HP205" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
                  </div>

                  <div className="flex flex-col">
                    <label htmlFor="employeeName" className="text-sm font-medium text-gray-700">Employee Name</label>
                    <input id="employeeName" defaultValue="Ahmed Hussain" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
                  </div>

                  <div className="flex flex-col">
                    <label htmlFor="employeeId" className="text-sm font-medium text-gray-700">Employee ID</label>
                    <input id="employeeId" defaultValue="40577" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
                  </div>

                  <div className="flex flex-col">
                    <label htmlFor="phoneNumber" className="text-sm font-medium text-gray-700">Phone Number</label>
                    <input id="phoneNumber" defaultValue="+966 123 762 1325" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
                  </div>

                  {/* Location Details */}
                  <div className="flex flex-col">
                    <label htmlFor="departmentCode" className="text-sm font-medium text-gray-700">Department Code</label>
                    <input id="departmentCode" defaultValue="05" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
                  </div>

                  <div className="flex flex-col">
                    <label htmlFor="department" className="text-sm font-medium text-gray-700">Department</label>
                    <input id="department" defaultValue="IT Department" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
                  </div>

                  <div className="flex flex-col">
                    <label htmlFor="businessName" className="text-sm font-medium text-gray-700">Business Name</label>
                    <input id="businessName" defaultValue="IT" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
                  </div>

                  <div className="flex flex-col">
                    <label htmlFor="buildingName" className="text-sm font-medium text-gray-700">Building Name</label>
                    <input id="buildingName" defaultValue="ADCB bldg" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
                  </div>

                  <div className="flex flex-col">
                    <label htmlFor="buildingNumber" className="text-sm font-medium text-gray-700">Building Number</label>
                    <input id="buildingNumber" defaultValue="45" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
                  </div>

                  <div className="flex flex-col">
                    <label htmlFor="buildingAddress" className="text-sm font-medium text-gray-700">Building Address</label>
                    <input id="buildingAddress" defaultValue="Khalidiya street" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
                  </div>

                  <div className="flex flex-col">
                    <label htmlFor="floorNumber" className="text-sm font-medium text-gray-700">Floor Number</label>
                    <input id="floorNumber" defaultValue="5" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
                  </div>

                  <div className="flex flex-col">
                    <label htmlFor="city" className="text-sm font-medium text-gray-700">City</label>
                    <input id="city" defaultValue="AL Ain City" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
                  </div>

                  <div className="flex flex-col">
                    <label htmlFor="region" className="text-sm font-medium text-gray-700">Region</label>
                    <input id="region" defaultValue="Abu Dhabi" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
                  </div>

                  <div className="flex flex-col">
                    <label htmlFor="country" className="text-sm font-medium text-gray-700">Country</label>
                    <input id="country" defaultValue="UAE" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
                  </div>
                </div>
              </div>
            </div>
          )}

        {activeTab === 'maintenance' && (
        <div>
            <h2 className="text-lg font-semibold mb-2 text-blue-900">Asset Maintenance Details</h2>
            {/* Responsive Grid */}
            <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
            
            {/* Left Section */}
            <div className="flex flex-col">
                <label htmlFor="assetId" className="text-sm font-medium text-gray-700">Asset ID / Tag Number</label>
                <input id="assetId" defaultValue="020002000041" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
            </div>

            <div className="flex flex-col">
                <label htmlFor="assetName" className="text-sm font-medium text-gray-700">Asset Name / Description</label>
                <input id="assetName" defaultValue="PRINTER HP205" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
            </div>

            <div className="flex flex-col">
                <label htmlFor="maintenanceType" className="text-sm font-medium text-gray-700">Maintenance Type</label>
                <input id="maintenanceType" defaultValue="Preventive Maintenance" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
            </div>

            {/* Second Row */}
            <div className="flex flex-col">
                <label htmlFor="lastMaintenanceDate" className="text-sm font-medium text-gray-700">Last Maintenance Date</label>
                <input id="lastMaintenanceDate" defaultValue="2024-10-15" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
            </div>

            <div className="flex flex-col">
                <label htmlFor="nextMaintenanceDate" className="text-sm font-medium text-gray-700">Next Maintenance Date</label>
                <input id="nextMaintenanceDate" defaultValue="2025-04-15" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
            </div>

            <div className="flex flex-col">
                <label htmlFor="servicingProvider" className="text-sm font-medium text-gray-700">Servicing Provider</label>
                <input id="servicingProvider" defaultValue="Nartec Solutions" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
            </div>

            {/* Third Row */}
            <div className="flex flex-col">
                <label htmlFor="contactInformation" className="text-sm font-medium text-gray-700">Contact Information</label>
                <input id="contactInformation" defaultValue="sample email@gmail.com" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
            </div>

            <div className="flex flex-col">
                <label htmlFor="workDescription" className="text-sm font-medium text-gray-700">Work Description</label>
                <input id="workDescription" defaultValue="Toner replacement and diagnostics" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
            </div>

            <div className="flex flex-col">
                <label htmlFor="partsUsed" className="text-sm font-medium text-gray-700">Parts Used</label>
                <input id="partsUsed" defaultValue="CT654123" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
            </div>

            {/* Fourth Row */}
            <div className="flex flex-col">
                <label htmlFor="maintenanceCost" className="text-sm font-medium text-gray-700">Maintenance Cost</label>
                <input id="maintenanceCost" defaultValue="$150 (Labor: $50, Parts: $100)" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
            </div>

            <div className="flex flex-col">
                <label htmlFor="warrantyCoverage" className="text-sm font-medium text-gray-700">Warranty Coverage</label>
                <input id="warrantyCoverage" defaultValue="Servicing Covered until 2025" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
            </div>

            <div className="flex flex-col">
                <label htmlFor="assetDownTime" className="text-sm font-medium text-gray-700">Asset Down Time</label>
                <input id="assetDownTime" defaultValue="2 Hrs" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
            </div>

            <div className="flex flex-col">
                <label htmlFor="maintenanceLog" className="text-sm font-medium text-gray-700">Maintenance Log</label>
                <input id="maintenanceLog" defaultValue="Record of Toner replacement" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
            </div>

            </div>
            {/* Update Button */}
            <div className="flex justify-end items-end w-full mt-4">
            <button className="bg-secondary text-white sm:w-[30%] w-full py-2 px-4 rounded-md hover:bg-[#95DCEA]">
                Update
            </button>
            </div>
        </div>
        )}

{activeTab === 'financial' && (
  <div>
    <h2 className="text-lg font-semibold mb-2 text-blue-900">Asset Financial Details</h2>
    {/* Responsive Grid */}
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      
      {/* First Row */}
      <div className="flex flex-col">
        <label htmlFor="assetName" className="text-sm font-medium text-gray-700">Asset Name / Description</label>
        <input id="assetName" defaultValue="PRINTER HP205" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
      </div>

      <div className="flex flex-col">
        <label htmlFor="acquisitionCost" className="text-sm font-medium text-gray-700">Acquisition Cost (SAR)</label>
        <input id="acquisitionCost" defaultValue="1500" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
      </div>

      <div className="flex flex-col">
        <label htmlFor="poDate" className="text-sm font-medium text-gray-700">PO Date</label>
        <input id="poDate" defaultValue="Preventive Maintenance" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
      </div>

      {/* Second Row */}
      <div className="flex flex-col">
        <label htmlFor="invoiceDate" className="text-sm font-medium text-gray-700">Invoice Date</label>
        <input id="invoiceDate" defaultValue="2024-10-15" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
      </div>

      <div className="flex flex-col">
        <label htmlFor="invoiceNumber" className="text-sm font-medium text-gray-700">Invoice Number</label>
        <input id="invoiceNumber" defaultValue="2025-04-15" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
      </div>

      <div className="flex flex-col">
        <label htmlFor="deliveryNote" className="text-sm font-medium text-gray-700">Delivery Note</label>
        <input id="deliveryNote" defaultValue="Nartec Solutions" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
      </div>

      {/* Third Row */}
      <div className="flex flex-col">
        <label htmlFor="capitalizationDate" className="text-sm font-medium text-gray-700">Capitalization Date</label>
        <input id="capitalizationDate" defaultValue="sample email@gmail.com" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
      </div>

      <div className="flex flex-col">
        <label htmlFor="depreciationMethod" className="text-sm font-medium text-gray-700">Depreciation Method</label>
        <input id="depreciationMethod" defaultValue="Toner replacement and diagnostics" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
      </div>

      <div className="flex flex-col">
        <label htmlFor="usefulLife" className="text-sm font-medium text-gray-700">Useful Life (Years)</label>
        <input id="usefulLife" defaultValue="5" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
      </div>

      {/* Fourth Row */}
      <div className="flex flex-col">
        <label htmlFor="residualValue" className="text-sm font-medium text-gray-700">Residual Value (SAR)</label>
        <input id="residualValue" defaultValue="150" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
      </div>

      <div className="flex flex-col">
        <label htmlFor="annualDepreciation" className="text-sm font-medium text-gray-700">Annual Depreciation (SAR)</label>
        <input id="annualDepreciation" defaultValue="100" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
      </div>

      <div className="flex flex-col">
        <label htmlFor="accumulatedDepreciation" className="text-sm font-medium text-gray-700">Accumulated Depreciation (SAR)</label>
        <input id="accumulatedDepreciation" defaultValue="100" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
      </div>

      {/* Fifth Row */}
      <div className="flex flex-col">
        <label htmlFor="netBookValue" className="text-sm font-medium text-gray-700">Net Book Value (SAR)</label>
        <input id="netBookValue" defaultValue="1500" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
      </div>

      <div className="flex flex-col">
        <label htmlFor="insuranceValue" className="text-sm font-medium text-gray-700">Insurance Value (SAR)</label>
        <input id="insuranceValue" defaultValue="1500" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
      </div>

      <div className="flex flex-col">
        <label htmlFor="impairmentLoss" className="text-sm font-medium text-gray-700">Impairment Loss (SAR)</label>
        <input id="impairmentLoss" defaultValue="0" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
      </div>

      {/* Sixth Row */}
      <div className="flex flex-col">
        <label htmlFor="disposalValue" className="text-sm font-medium text-gray-700">Disposal Value (SAR)</label>
        <input id="disposalValue" defaultValue="0" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
      </div>

      <div className="flex flex-col">
        <label htmlFor="gainLossOnDisposal" className="text-sm font-medium text-gray-700">Gain/Loss on Disposal (SAR)</label>
        <input id="gainLossOnDisposal" defaultValue="0" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
      </div>

      <div className="flex flex-col">
        <label htmlFor="taxDeductionBenefit" className="text-sm font-medium text-gray-700">Tax Deduction Benefit (SAR)</label>
        <input id="taxDeductionBenefit" defaultValue="100" className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm" />
      </div>

    </div>
    {/* Update Button */}
    <div className="flex justify-end items-end w-full mt-4">
      <button className="bg-secondary text-white sm:w-[30%] w-full py-2 px-4 rounded-md hover:bg-[#95DCEA]">
        Update
      </button>
    </div>
  </div>
)}

{activeTab === 'history' && (
  <div>
    <h2 className="text-lg font-semibold mb-2 text-blue-900">Asset History Details</h2>
    <div className="overflow-x-auto">
      <table className="min-w-full bg-white border border-gray-300 rounded-lg">
        <thead className="bg-blue-900 text-white">
          <tr>
            <th className="px-4 py-2 text-left">S/N</th>
            <th className="px-4 py-2 text-left">Transaction Type</th>
            <th className="px-4 py-2 text-left">Date</th>
            <th className="px-4 py-2 text-left">Amount (SAR)</th>
            <th className="px-4 py-2 text-left">Description</th>
            <th className="px-4 py-2 text-left">Checker</th>
          </tr>
        </thead>
        <tbody className="font-medium">
          <tr className="border-b">
            <td className="px-4 py-2">1</td>
            <td className="px-4 py-2">Acquisition</td>
            <td className="px-4 py-2">2023-01-01</td>
            <td className="px-4 py-2">1500</td>
            <td className="px-4 py-2">Purchase and Installation</td>
            <td className="px-4 py-2">Mr Majid</td>
          </tr>
          <tr>
            <td className="px-4 py-2">2</td>
            <td className="px-4 py-2">Maintenance</td>
            <td className="px-4 py-2">2023-06-01</td>
            <td className="px-4 py-2">100</td>
            <td className="px-4 py-2">Performed regular maintenance</td>
            <td className="px-4 py-2">Mr Hasnain</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
)}

{activeTab === 'api' && (
  <div>
    <h2 className="text-lg font-semibold mb-2 text-blue-900">API Details</h2>

    {/* Search and Toggle Bar */}
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mb-4">
      {/* Search Bar */}
      <div className="flex flex-col">
        <label htmlFor="searchOperations" className="text-sm font-medium text-gray-700">Search Operations</label>
        <input
          id="searchOperations"
          type="text"
          placeholder="Search Operations"
          className="mt-1 w-full p-2 border border-[#0B469F] rounded-sm"
          value={searchTerm}
          onChange={(e) => setSearchTerm(e.target.value)}
        />
      </div>

      {/* Group by Tag Switch */}
      <div className="flex flex-col">
        <label htmlFor="groupByTag" className="text-sm font-medium text-gray-700">Group by Tag</label>
        <div className="mt-1 flex items-center">
          <Switch checked={groupByTag} onCheckedChange={setGroupByTag} />
          <span className="ml-2 text-sm font-medium text-gray-700">On</span>
        </div>
      </div>
    </div>

    {/* Table */}
    <div className="overflow-x-auto bg-white p-4 rounded-lg shadow-md">
      <table className="min-w-full rounded-sm shadow-sm">
        <thead className="bg-white font-medium">
          <tr>
            <th className="px-4 py-2 text-left font-medium">Name</th>
            <th className="px-4 py-2 text-left font-medium">Description</th>
            <th className="px-4 py-2 text-left font-medium">Type</th>
          </tr>
        </thead>
        <tbody className="text-sm">
          {filteredOperations.map((operation, index) => (
            <tr key={index} className="border-b hover:bg-gray-50">
              <td className="px-4 py-2 font-medium">{operation.name}</td>
              <td className="px-4 py-2">{operation.description}</td>
              <td className="px-4 py-2">{operation.type}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  </div>
)}

        </div>
      </div>
    </div>
  );
}

export default ViewVerifiedAsset;
